import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { PrivacyPolicyInitStepDeclaration } from "./Steps/PrivacyPolicyInitStep";

export const PrivacyPolicyStartupFlow = new FlowDefinition("PrivacyPolicyFlow");

PrivacyPolicyStartupFlow.addStep(PrivacyPolicyInitStepDeclaration);

PrivacyPolicyStartupFlow.setStartStep("PrivacyPolicyInit_Step");

export const PrivacyPolicyStartupStepDefinition = new StepDefinition({
    stepName: "PrivacyPolicyFlow",
    stepFlow: PrivacyPolicyStartupFlow,
    contextIsolation: false
})